export default __webpack_public_path__ + "static/media/incorrect-icon-light.00d35eb2.svg";